<template>
  <div>
    <v-card>
      <v-toolbar>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title
          >Редактировать пользователя: {{ user.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn @click="save"> <v-icon left>save</v-icon>Записать </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            label="Логин (изменить нельзя)"
            readonly
            v-model="user.email"
          ></v-text-field>

          <v-text-field
            :rules="rules.nameRules"
            required
            label="*Фамилия"
            v-model="user.famil"
          ></v-text-field>

          <v-text-field
            :rules="rules.nameRules"
            required
            label="*Имя"
            v-model="user.profile_name"
          ></v-text-field>

          <v-text-field label="Отчество" v-model="user.otch"></v-text-field>

          <v-text-field
            :rules="rules.emailRules"
            required
            prepend-icon="email"
            type="email"
            label="Контактный Email"
            v-model="user.emailContact"
          ></v-text-field>

          <v-text-field
            placeholder="(xxx)xxx xx xx"
            prepend-icon="phone"
            v-mask="rules.phonemask"
            prefix="+7"
            :rules="rules.phoneRules"
            label="№ телефона"
            v-model="user.phone"
          ></v-text-field>
          <v-text-field
            label="Комментарий к телефону"
            v-model="user.phone_note"
          ></v-text-field>

          <v-text-field
            label="Должность"
            v-model="user.position"
          ></v-text-field>

          <v-text-field label="Адрес" v-model="user.address"></v-text-field>

          <v-text-field
            label="Краткая информация"
            v-model="user.bio"
          ></v-text-field>

          <v-text-field
            label="Дата рождения"
            type="date"
            v-model="user.date"
          ></v-text-field>

          <v-select
            v-model="user.role"
            :items="roles"
            item-text="name"
            item-value="role"
            label="Роль"
            required
            :rules="rules.emptyRules"
          ></v-select>
          <v-checkbox label="Активирован" v-model="user.active"></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Отмена (закрыть)</v-btn>
        <v-btn @click="save">Записать</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-text-field
          :rules="rules.passwordRules"
          required
          id="password"
          counter="16"
          label="Пароль"
          v-model="password1"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
        ></v-text-field>
        <v-text-field
          :rules="rules.passwordRules"
          required
          id="password2"
          counter="16"
          label="Повторить пароль"
          v-model="password2"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show2 ? 'text' : 'password'"
          @click:append="show2 = !show2"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="generatePwd">сгенерировать пароль</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" :disabled="loading" @click="saveAndEmail"
          >Записать и отправить на Email</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          :disabled="loading"
          @click="saveAndEmailAnonymous"
          >Отправить и показать только ему</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Globalrules from "../../components/api/rules.js";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      show1: false,
      show2: false,
      loading: false,
      password1: "",
      password2: "",
      rules: Globalrules,
      error: "",
      valid: true,
      orgPravForm: [
        { name: "Юридическое лицо", id: "1" },
        { name: "Индивидуальный предриниматель ", id: "2" },
      ],
      vidnologObl: [
        { name: "ОСН", id: 1 },
        { name: "УСН", id: 2 },
        { name: "Другая", id: 3 },
      ],
    };
  },
  methods: {
    close() {
      this.$router.push({ name: "usersorganisationtable" });
    },
    makeGoodField(val) {
      if (!val) return "";
      else return val;
    },
    save() {
      var data;

      if (!this.user.profile_name) {
        Swal.fire({
          icon: "error",
          title: "Ошибка",
          text: "Поле 'Имя' обязательно к заполнению ",
        });
        return;
      }
      if (!this.user.emailContact) {
        Swal.fire({
          icon: "error",
          title: "Ошибка",
          text: "Поле 'Контактный Email' обязательно к заполнению ",
        });
        return;
      }

      data = {
        id: this.user.user_id,
        famil: this.makeGoodField(this.user.famil),
        name: this.makeGoodField(this.user.profile_name),
        otch: this.makeGoodField(this.user.otch),
        position: this.makeGoodField(this.user.position),
        phone: this.makeGoodField(this.user.phone),
        phone_note: this.makeGoodField(this.user.phone_note),
        address: this.makeGoodField(this.user.address),
        bio: this.makeGoodField(this.user.bio),
        date: this.makeGoodField(this.user.date),
        emailContact: this.user.emailContact,
        profile_active: this.user.active,
        role: this.user.role,
      };

      this.$store.dispatch("updateUserManagementFirmSotr", data).then(() => {
        if (this.$store.getters.getErrorApi == "ADMINFOREVER") {
          Swal.fire({
            icon: "warning",
            title: "Роль не изменилась",
            text: "Нельзя лишить себя роли администратора.",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "удачно!",
            text: "Данные сотрудника обновлены",
          });
        }
      });
    },

    gen_password(len) {
      var password = "";
      var symbols =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!№;%:?*()_+=";
      for (var i = 0; i < len; i++) {
        password += symbols.charAt(Math.floor(Math.random() * symbols.length));
      }
      return password;
    },

    generatePwd() {
      var pwd = this.gen_password(8);
      this.password1 = this.password2 = pwd;
    },

    saveAndEmailAnonymous() {
      this.loading = true;
      var data = {
        user_id: this.user.user_id,
      };
      this.$store
        .dispatch("changePasswordUserOfFirmAnon", data)
        .then(() => {
          if (this.$store.getters.getErrorApi == "OK") {
            Swal.fire({
              icon: "success",
              title: "Успешно!",
              text: "Пароль изменен на новый",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.error = error;
          this.loading = false;
        });
    },
    saveAndEmail() {
      if (this.password1 != this.password2) {
        Swal.fire({
          icon: "error",
          title: "Ошибка!",
          text: "Пароли должны совпадать.",
        });
        return;
      }
      if (this.password1.length < 6) {
        Swal.fire({
          icon: "error",
          title: "Ошибка!",
          text: "Длина пароля не должна быть меньше 6 символов.",
        });
        return;
      }
      this.loading = true;
      var data = {
        password: this.password1,
        user_id: this.user.user_id,
      };
      this.$store
        .dispatch("changePasswordUserOfFirm", data)
        .then(() => {
          if (this.$store.getters.getErrorApi == "PASSWORDERROR") {
            Swal.fire({
              icon: "error",
              title: "Ошибка!",
              text: "Неверный формат пароля",
            });
          } else if (this.$store.getters.getErrorApi == "OK") {
            Swal.fire({
              icon: "success",
              title: "Успешно!",
              text: "Пароль изменен на новый",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.error = error;
          this.loading = false;
        });
    },
  },
  computed: {
    user() {
      return this.$store.getters.GetCurrentOrganisationUserUM;
    },
    roles() {
      return this.getRoles();
    },
  },
  mounted() {
    this.setTitle(`Редактировать пользователя: ${this.user.name}`);
  },
};
</script>

<style lang="scss"></style>
